import { Box } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";

const BannerCloseButton = () => {
  const { dismissBanner } = useContext(SubscriptionContext);
  return (
    <Box
      component="button"
      aria-label="Dismiss"
      onClick={(e) => {
        e.stopPropagation();
        dismissBanner();
      }}
      sx={{
        position: "absolute",
        right: { xs: 10, md: 16 },
        top: "50%",
        transform: "translateY(-50%)",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "rgba(255,255,255,0.7)",
        fontSize: 16,
        display: "inline-flex",
        p: 0.5,
        zIndex: 1,
        "&:hover": { color: "#fff" },
      }}
    >
      <Box component="i" className="fa-solid fa-xmark" />
    </Box>
  );
};

export default BannerCloseButton;
